export enum ReleaseNoteCategory {
  Feature = 0,
  BugFix = 1,
  Improvement = 2,
  Breaking = 3,
  Other = 4,
}

export enum ReleaseNotePlatform {
  All = 0,
  Web = 1,
  Mobile = 2,
  Api = 3,
}

export const CATEGORY_LABELS: Record<ReleaseNoteCategory, string> = {
  [ReleaseNoteCategory.Feature]: 'Feature',
  [ReleaseNoteCategory.BugFix]: 'Bug Fix',
  [ReleaseNoteCategory.Improvement]: 'Improvement',
  [ReleaseNoteCategory.Breaking]: 'Breaking Change',
  [ReleaseNoteCategory.Other]: 'Other',
};

export const PLATFORM_LABELS: Record<ReleaseNotePlatform, string> = {
  [ReleaseNotePlatform.All]: 'All',
  [ReleaseNotePlatform.Web]: 'Web',
  [ReleaseNotePlatform.Mobile]: 'Mobile',
  [ReleaseNotePlatform.Api]: 'API',
};

export interface ReleaseListItemDto {
  id: number;
  webVersion: string;
  mobileVersion: string;
  title: string;
  releaseDate: string;
  isPublished: boolean;
  noteCount: number;
  highlightCount: number;
}

export interface ReleaseNoteItemDto {
  id: number;
  category: ReleaseNoteCategory;
  platform: ReleaseNotePlatform;
  description: string;
  sortOrder: number;
}

export interface ReleaseHighlightDto {
  id: number;
  moduleName: string;
  content: string;
  sortOrder: number;
}

export interface ReleaseDto {
  id: number;
  webVersion: string;
  mobileVersion: string;
  title: string;
  summary: string | null;
  releaseDate: string;
  isPublished: boolean;
  createdAt: string;
  notes: ReleaseNoteItemDto[];
  highlights: ReleaseHighlightDto[];
}

export interface ReleaseNoteItemRequest {
  category: ReleaseNoteCategory;
  platform: ReleaseNotePlatform;
  description: string;
  sortOrder: number;
}

export interface ReleaseHighlightRequest {
  moduleName: string;
  content: string;
  sortOrder: number;
}

export interface CreateReleaseRequest {
  webVersion: string;
  mobileVersion: string;
  title: string;
  summary?: string | null;
  releaseDate: string;
  isPublished: boolean;
  notes: ReleaseNoteItemRequest[];
  highlights: ReleaseHighlightRequest[];
}

export interface UpdateReleaseRequest {
  webVersion: string;
  mobileVersion: string;
  title: string;
  summary?: string | null;
  releaseDate: string;
  isPublished: boolean;
  notes: ReleaseNoteItemRequest[];
  highlights: ReleaseHighlightRequest[];
}
